import {
    HIGHLIGHT_IN_MAP,
    CLEAR_MAP_HIGHLIGHT,
    NAVIGATE_CAROUSEL,
    CLEAR_CAROUSEL_FOCUS,
    HIDE_GOOGLE_MAP,
} from './action-types';

export function highlightInMap(listingId) {
    return {
        type: HIGHLIGHT_IN_MAP,
        listingId,
    };
}

export function clearMapHighlight() {
    return {
        type: CLEAR_MAP_HIGHLIGHT,
    };
}

export function navigateCarousel(listingId) {
    return {
        type: NAVIGATE_CAROUSEL,
        listingId,
    };
}

export function clearCarouselFocus() {
    return {
        type: CLEAR_CAROUSEL_FOCUS,
    };
}

export function hideGoogleMap() {
    return {
        type: HIDE_GOOGLE_MAP,
    };
}
